import httpUtils from '../../utils/HttpUtils'

class SupervisorWorkerService {

  async list () {
    var result = null;
    try {
      result = await httpUtils.post('/server/supervisor/worker/list');
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  async detail (id) {
    var result = null;
    try {
      result = await httpUtils.post('/server/supervisor/worker/detail',{id});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
}
export default new SupervisorWorkerService()
